import React, { useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';

const ProtectedRoute = ({ children, allowedRoles = [] }) => {
  const { user, userProfile, loading, profileLoading } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    // Wait for both auth and profile loading to complete before redirecting
    if (!loading && !profileLoading) {
      if (!user) {
        navigate('/login');
      } else if (allowedRoles?.length > 0 && userProfile && !allowedRoles?.includes(userProfile?.role)) {
        const roleRoutes = {
          admin: '/admin-dashboard',
          editor: '/editor-dashboard',
          artist: '/artist-content-management'
        };
        const userRole = userProfile?.role;
        const redirectPath = roleRoutes?.[userRole] || '/login';
        navigate(redirectPath);
      }
    }
  }, [user, userProfile, loading, profileLoading, navigate, allowedRoles]);

  // Show loading while auth or profile is initializing
  if (loading || profileLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-32 w-32 border-b-2 border-primary"></div>
      </div>
    );
  }

  if (!user) {
    return null;
  }

  if (allowedRoles?.length > 0 && userProfile && !allowedRoles?.includes(userProfile?.role)) {
    return null;
  }

  return children;
};

export default ProtectedRoute;